import { combineReducers } from 'redux';
import { RootAction } from '@src/app/_redux';
import {
  STOP_AUTO_RENEW_LOADING,
  STOP_AUTO_RENEW_ERROR,
  STOP_AUTO_RENEW_START,
  STOP_AUTO_RENEW_SUCCESS,
  STOP_AUTO_RENEW_CANCEL,
} from '@src/app/accounts/stopautorenew/actions';
import { OMS_LOOKUP_SUCCESS } from '@src/app/login/oms/actions';
export type State = {
  readonly loading: boolean;
  stopAutoRenewSavedResult: Object | null;
};

export const reducer = combineReducers<State, RootAction>({
  loading: (state = false, action) => {
    switch (action.type) {
      case STOP_AUTO_RENEW_ERROR:
      case STOP_AUTO_RENEW_START:
      case OMS_LOOKUP_SUCCESS:
        return false;
      case STOP_AUTO_RENEW_LOADING:
        return action.payload;
      default:
        return state;
    }
  },

  stopAutoRenewSavedResult: (state = null, action) => {
    switch (action.type) {
      case STOP_AUTO_RENEW_SUCCESS:
      case STOP_AUTO_RENEW_ERROR:
        return action.payload;
      case STOP_AUTO_RENEW_CANCEL:
      case STOP_AUTO_RENEW_START:
        return null;
      default:
        return state;
    }
  },
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/accounts/stopautorenew/reducer.ts